import SvgAdditionDetails from "./SvgAdditionDetails";
import SvgBilling from "./SvgBilling";
import SvgContact from "./SvgContact";
import SvgDelivery from "./SvgDelivery";
import SvgOrderSummary from "./SvgOrderSummary";
import SvgPayment from "./SvgPayment";
import SvgPickup from "./SvgPickup";
import SvgPopUpDelivery from "./SvgPopUpDelivery";
import SvgPopUpDeliveryTime from "./SvgPopUpDeliveryTime";
import SvgReceiving from "./SvgReceiving";
import SvgShipping from "./SvgShipping";

export enum CheckoutIcons {
  additionDetails,
  billing,
  delivery,
  order,
  payment,
  pickup,
  receiving,
  shipping,
  popUpDelivery,
  popUpDeliveryTime,
  contact,
}

interface Props {
  svg: CheckoutIcons;
  mobile: boolean;
}
const GetCheckoutSvg: React.FC<Props> = ({ svg, mobile }) => {
  switch (svg) {
    case CheckoutIcons.additionDetails:
      return <SvgAdditionDetails mobile={mobile} />;
    case CheckoutIcons.billing:
      return <SvgBilling mobile={mobile} />;
    case CheckoutIcons.delivery:
      return <SvgDelivery mobile={mobile} />;
    case CheckoutIcons.order:
      return <SvgOrderSummary mobile={mobile} />;
    case CheckoutIcons.payment:
      return <SvgPayment mobile={mobile} />;
    case CheckoutIcons.pickup:
      return <SvgPickup mobile={mobile} />;
    case CheckoutIcons.receiving:
      return <SvgReceiving mobile={mobile} />;
    case CheckoutIcons.shipping:
      return <SvgShipping mobile={mobile} />;
    case CheckoutIcons.popUpDelivery:
      return <SvgPopUpDelivery />;
    case CheckoutIcons.popUpDeliveryTime:
      return <SvgPopUpDeliveryTime />;
    case CheckoutIcons.contact:
      return <SvgContact />;
    default:
      return null;
  }
};

export default GetCheckoutSvg;
